module.exports = __webpack_public_path__ + "static/media/learning-9.910788e0.png";